import { connectApi } from "@api/coreApi";
import { baseURL } from "@api/endpoints";

// export const fetchEnquiryHistory = ({ lang, email, phone, sua_id, token }) =>
//   connectApi({
//     method: "GET",
//     url: `${baseURL.fetchEnquiryHistory}?lang=${lang}&email=${email}&phone=${phone}&sua_id=${sua_id}&token=${token}`,
//   });

export const getEnrollmentList = ({ lang, email, phone }) =>
  connectApi({
    method: "GET",
    url: `${baseURL.getEnrollmentList}?lang=${lang}&email=${email}&phone=${phone}`,
  });

export const getWorkshopListById = ({ workshop_detail_id }) =>
  connectApi({
    method: "GET",
    url: `${baseURL.getWorkshopListById}?workshop_detail_id=${workshop_detail_id}`,
  });

export const getWorkshopListByWorkshopId = ({ workshop_id }) =>
  connectApi({
    method: "GET",
    url: `${baseURL.getWorkshopListByWorkshopId}?workshop_id=${workshop_id}`,
  });

export const modifyWorkshopEnrollment = (payload) =>
  connectApi({
    method: "POST",
    url: baseURL.modifyWorkshopEnrollment,
    payload,
  });

export const cancelWorkshopEnrollment = (payload) =>
  connectApi({
    method: "POST",
    url: baseURL.cancelWorkshopEnrollment,
    payload,
  });
